import { render, staticRenderFns } from "./PopupOrderEnvironmentLinks.vue?vue&type=template&id=65e38d4e&scoped=true&"
import script from "./PopupOrderEnvironmentLinks.vue?vue&type=script&lang=js&"
export * from "./PopupOrderEnvironmentLinks.vue?vue&type=script&lang=js&"
import style0 from "./PopupOrderEnvironmentLinks.vue?vue&type=style&index=0&id=65e38d4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e38d4e",
  null
  
)

export default component.exports